<template>

  <div class="">
    <a-row :gutter="[16, 16]">
      <a-col :span="20">
        <a-form :colon="false" id="check" :form="form" v-bind="formItemLayout">
          <a-form-item label="系统" class="form-img">
            <!-- <img :src="$store.state.check.choosedPrd.smallPic" /> -->
            <div class="pro_logo">
              <img src="@/assets/images/wf_logo_product.png" />
              <span>{{ $store.state.check.choosedPrd.productName }}</span>
            </div>
          </a-form-item>
          <a-form-item label="题目">
            <a-input
              placeholder="最多输入50个字"
              :maxLength="50"
              v-decorator="[
                'title',
                {
                  rules: [{ required: true, message: '请输入题目!' }, { validator: this.checkSpecialInput }],
                  initialValue: $store.state.check.fieldsValue ? $store.state.check.fieldsValue.title: '',
                },
              ]"
            />
          </a-form-item>
          <a-form-item label="作者">
            <a-input
              placeholder="多个作者请用逗号隔开，最多输入15个字"
              :maxLength="15"
              v-decorator="[
                'author',
                {
                  rules: [{ required: true, message: '请输入作者!' }, { validator: this.checkSpecialInput }],
                  initialValue: $store.state.check.fieldsValue ? $store.state.check.fieldsValue.author : '',
                },
              ]"
            />
          </a-form-item>
          <a-form-item label="日期" v-bind="formItemLayout2">
            <a-date-picker
              placeholder=""
              v-decorator="[
                'publishdate',
                {
                  rules: [{ required: true, message: '请输入发布日期!' }],
                  initialValue: $store.state.check.fieldsValue.publishdate ? moment(new Date($store.state.check.fieldsValue.publishdate)) : moment().format('YYYY-MM-DD'),
                },
              ]"
              format="YYYY-MM-DD"
              style="width: 100%"
            />
          </a-form-item>
          <a-form-item label="方式">
            <a-tabs @change="changeTab" :active-key="$store.state.check.tabKey">
              <a-tab-pane key="1" tab="上传文档" class="attention">
                <a-form-item>
                  <a-row>
                    <a-col :span="8">
                      <a-upload
                        :action="'/thesisCheck/api/file/upload'"
                        name="file"
                        :file-list="$store.state.check.fileList"
                        @change="handleChange"
                        :before-upload="beforeUpload"
                      >
                        <a-button type="primary">
                          <a-icon type="upload" /> 选择文件
                        </a-button>
                      </a-upload></a-col
                      >
                    <a-col :span="16">
                      <a-textarea
                        :placeholder="`填写需检测内容，字数限制大于500字，小于${$store.state.check.activeObj.maxNum}字`"
                        :auto-size="{ minRows: 1, maxRows: 6 }"
                        disabled
                      />
                    </a-col>
                  </a-row>
                </a-form-item>
                <div>
                  <div class="tit">注意事项:</div>
                  <p>
                    1.系统直通检测官网，是从官方下载的报告，支持所有报告验真，若有假冒，全额退款。如有任何的疑问可联系客服解决。
                  </p>
                  <p>
                    2.文档大小请不要超过
                    <span class="imp">30M</span
                    >，否则将无法上传。可将论文中的图片删除（系统不检测图片）。
                  </p>
                  <p>
                    3.支持文档格式：WORD文件（.doc .docx）、文本文件（.txt）
                  </p>
                </div>
              </a-tab-pane>
              <a-tab-pane key="2" tab="粘贴上传">
                <ATextarea
                  ref="textAreaRef"
                  v-decorator="[
                    'content',
                    {
                      initialValue: $store.state.check.inputText,
                    },
                  ]"
                  :placeholder="`填写需要检测内容，字数限制大于500字，小于${$store.state.check.activeObj.maxNum}字，提交内容建议去除封面、目录，仅提交正文`"
                  :auto-size="{ minRows: 10, maxRows: 10 }"
                  autofocus="autofocus"
                  @change="contTextNum"
                />
              </a-tab-pane>
              <span slot="tabBarExtraContent" v-if="$store.state.check.tabKey === '1'">
                计费方式:
                <span v-if="$store.state.check.activeObj.unitType === 'NUM'">{{ $store.state.check.activeObj.userPrice }}元 /{{ $store.state.check.activeObj.unit }}字, 当前已输入 {{ $store.state.check.fileCount }} 字符</span>
                <span v-else>{{ $store.state.check.activeObj.userPrice }}元 /篇, 当前已输入 {{ $store.state.check.fileCount }} 字符</span>
              </span>
              <span slot="tabBarExtraContent" v-if="$store.state.check.tabKey === '2'">
                计费方式:
                <span v-if="$store.state.check.activeObj.unitType === 'NUM'">{{ $store.state.check.activeObj.userPrice }}元 /{{ $store.state.check.activeObj.unit }}字, 当前已输入 {{ $store.state.check.inputCount }} 字符</span>
                <span v-else>{{ $store.state.check.activeObj.userPrice }}元 /篇, 当前已输入 {{ $store.state.check.inputCount }} 字符</span>
              </span>
            </a-tabs>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { Row, Col, Icon, Form, Input, Tabs, Button, Upload, DatePicker } from 'ant-design-vue'
import moment from 'moment'
export default {
  name: 'Submit',
  components: {
      ARow: Row,
      ACol: Col,
      // ACard: Card,
      AIcon: Icon,
      AForm: Form,
      AFormItem: Form.Item,
      AInput: Input,
      ATextarea: Input.TextArea,
      ATabs: Tabs,
      ATabPane: Tabs.TabPane,
      AButton: Button,
      AUpload: Upload,
      ADatePicker: DatePicker,
      // DictSelect,
      // DictAuto,
    },
  data: () => ({
    formItemLayout: {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
    },
    formItemLayout2: {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
    },
    // tabKey: '1',
    fileList: [],
    // fileCount: 0,
    // fileCount1: 0,
    moment
  }),
  beforeCreate () {
    this.form = this.$form.createForm(this, { name: 'wfContent' })
  },
  created () {
    // this.$store.dispatch('check/getQRcodeUrl')
  },
  methods: {
    changeTab (key) {
      // this.tabKey = key
      this.$store.commit('check/saveTabKey', {
        tabKey : key
      })
      // if(this.tabKey==='2'){
      //   const textArea = this.$refs.textAreaRef
      //   textArea.focus()
      //   textArea.setSelectionRange(0, textArea.value.length);
      //   debugger
      // }
    },
    handleChange (info) {
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      fileList = fileList.map(file => {
        if (file.status === 'uploading') {
          return file
        }
        if (file.status === 'done' && file.response && file.response.data) {
          const values = this.form.getFieldsValue()
          if (!values.title) {
            this.form.setFieldsValue({
              title: file.response.data.fileName.substring(0, 50),
            })
          }
          this.$store.commit('check/saveFileCount', {
            fileCount: file.response.data.wordNumber
          })
          return {
            ...file,
            ...file.response.data
          }
        }
      })
      this.fileList = fileList[0] && fileList || []
      this.$store.commit('check/saveFileList', {
        fileList : this.fileList
      })
    },
    beforeUpload (file) {
      // const fileType = file.type === 'text/plain' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type === 'application/msword' || file.type === 'application/pdf'
      const fileType = file.name.endsWith('.doc') || file.name.endsWith('.docx') || file.name.endsWith('.txt')
      if (!fileType) {
        this.$message.error('支持文档格式：WORD文件（.doc .docx）、文本文件（.txt）')
      }
      const isLt2M = file.size / 1024 / 1024 < 30
      if (!isLt2M) {
        this.$message.error('文件不能大于 30MB!')
      }
      return fileType && isLt2M
    },
    contTextNum (e) {
      let str = e.target.value
      // //去掉回车换行符
      str = str.replace(/\n+/g, '')
      this.$store.commit('check/saveInputCount', {
          inputText:str,
          inputCount: str.length
      })
    },
    checkSpecialInput (rule, value, callback) {
      const specialInput = new RegExp('[*]')
      const blankInput = /\s/g
      if (specialInput.test(value)) {
        callback(new Error("不能包含符号'*'"))
      }
      if(value.match(blankInput)){
        callback(new Error("不能包含空格符"))
      }
       callback()
    },
  }
}
</script>

<style lang="less" scoped>
.pro_logo {
  width:243px;
  height:50px;
  line-height:50px;
  background-color: #093D7C;
  border-radius:5px;
  text-align: center;
  img {
    margin: 5px 10px 12px 0;
  }
  span {
    font-size:20px;
    color:#fff;
  }
}
.form-img {
  text-align: left;
}

</style>
